import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import useStatusThunk from "../../hook/useStatusThunk";
import { fetchTaskRowContextNotes } from "../../redux/ducks/task";

const TaskNotes = props => {

    const selectedTaskRowID = useSelector(state => state.task.tasks[props.taskID]?.selectedRow);
    const rows = useSelector(state => state.task.tasks[props.taskID]?.rows);
    const [dispatch_fetch, status_fetch, error_fetch, e_fetch] = useStatusThunk(fetchTaskRowContextNotes);

    /* Fetch notes for selected row */
    useEffect(() => {
        dispatch_fetch({rowID:selectedTaskRowID, taskID: props.taskID});
    }, [selectedTaskRowID]);

    if (!rows) return <div></div>;

    const selectedTaskRow = rows[selectedTaskRowID];
    if (!selectedTaskRow) return <div />;
    if (!selectedTaskRow.contextKey && !selectedTaskRow.notes) return <div />;

    return <div className="note-block">
        <table>
            <tr>
                <td>KEY</td>
                <td>{selectedTaskRow.contextKey}</td>
            </tr>
            {selectedTaskRow.notes ? selectedTaskRow.notes.map((note, index) => <tr>
                <td>
                    {note.label}
                </td>

                <td>
                    {note.text}
                </td>
            </tr>) : ""}
        </table>
    </div>
}

export default TaskNotes;